import request from '../../../api/request';
import {
  AdditionalCharge,
  AdditionalChargeFormData,
  AdditionalChargeRequest,
} from './interfaces/types';

const ADDITIONAL_CHARGES_ENDPOINT = {
  LIST: (type: string) =>
    `maintainers-portal/general-configuration/additional-charges?type=${type}`,
  FORM_DATA: `maintainers-portal/general-configuration/additional-charges/form`,
  CREATE: `maintainers-portal/general-configuration/additional-charges`,
  UPDATE: (id: number) =>
    `maintainers-portal/general-configuration/additional-charges/${id}`,
  DELETE: (id: number) =>
    `maintainers-portal/general-configuration/additional-charges/${id}`,
};

export async function listByType(type: string) {
  return request<AdditionalCharge[]>(ADDITIONAL_CHARGES_ENDPOINT.LIST(type));
}

export async function getFormData() {
  return request<AdditionalChargeFormData>(
    ADDITIONAL_CHARGES_ENDPOINT.FORM_DATA,
  );
}

export async function createAdditionalCharge(data: AdditionalChargeRequest) {
  return request(ADDITIONAL_CHARGES_ENDPOINT.CREATE, {
    method: 'POST',
    data,
  });
}

export async function updateAdditionalCharge(
  id: number,
  data: AdditionalChargeRequest,
) {
  return request(ADDITIONAL_CHARGES_ENDPOINT.UPDATE(id), {
    method: 'PUT',
    data,
  });
}

export async function deleteAdditionalCharge(id: number) {
  return request(ADDITIONAL_CHARGES_ENDPOINT.DELETE(id), {
    method: 'DELETE',
  });
}
